var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat-card',{attrs:{"label":"Premières places","loading":_vm.loading,"stat":(_vm.firstPlaces + " (" + (Math.ceil(
    (_vm.firstPlaces / _vm.results.length) * 100
  )) + "%)"),"color-class":"bg-green-500","neutral-badge":_vm.year}},[_c('academic-cap-icon',{staticClass:"w-6 h-6 text-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }